/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable react/forbid-elements */

import { FC } from "react";
import { useLocation } from "../hooks/useLocation";
import { useNavigate } from "../hooks/useNavigate";
import { setCookie } from "../miscellaneous/cookieManagement";

type Props = {
  readonly languageIso?: string;
  readonly isOnClickDisabled?: boolean;
  readonly language?: string;
};

export const BreadCrumbsLanguageOption: FC<Props> = ({
  languageIso,
  isOnClickDisabled,
  language,
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const selectLanguageHandler = () => {
    if (language && languageIso) {
      navigate(pathname, { replace: true });
      setCookie("MkHcLang", languageIso);
      window.location.reload();
    }
  };

  return (
    <div className="mkhc-hover-link-container">
      <button
        className="mkhc-hover-link"
        onClick={isOnClickDisabled ? undefined : selectLanguageHandler}
      >
        <span className="tw-font-medium tw-whitespace-nowrap">{language}</span>
      </button>
    </div>
  );
};
